export enum StorageType {
  DROPBOX = "dropbox",
  GDRIVE = "gdrive",
  BOX = "box",
  ONEDRIVE = "onedrive",
  SHAREPOINT = "sharepoint",
  RSS = "rss",
  BRANDFOLDER = "brand_folder"
}
interface StorageAction {
  id: string;
  name: string;
  storageType: StorageType;
  image: string;
}

export const getStorageDetails = (type: StorageType): StorageAction => {
  switch (type) {
    case StorageType.DROPBOX:
      return { id: "dropbox", name: "Dropbox", storageType: StorageType.DROPBOX, image: "/images/dataSource/dropbox.png" };
    case StorageType.GDRIVE:
      return { id: "gdrive", name: "Google Drive", storageType: StorageType.GDRIVE, image: "/images/dataSource/gdrive.png" };
    case StorageType.BOX:
      return { id: "box", name: "Box", storageType: StorageType.BOX, image: "/images/dataSource/box.png" };
    case StorageType.ONEDRIVE:
      return { id: "onedrive", name: "OneDrive", storageType: StorageType.ONEDRIVE, image: "/images/dataSource/onedrive.png" };
    case StorageType.SHAREPOINT:
      return { id: "sharepoint", name: "SharePoint", storageType: StorageType.SHAREPOINT, image: "/images/dataSource/sharepoint.png" };
    case StorageType.RSS:
      return { id: "rss", name: "RSS", storageType: StorageType.RSS, image: "/images/dataSource/rss.png" };
    case StorageType.BRANDFOLDER:
      return { id: "brandfolder", name:"BrandFolder", storageType: StorageType.BRANDFOLDER, image: "/images/dataSource/brandfolder.png" };
  }
};